import React from "react";
import { Navigate } from "react-router-dom";
import { isDevMode } from "./authConfig";

const PrivateRoute = ({ children }) => {
  // 🔥 DEV MODE: Her zaman geçir
  if (isDevMode()) {
    console.log("🔥 DEV MODE: PrivateRoute bypassed");
    return children;
  }

  // Production mode: Normal kontrol
  const token = localStorage.getItem("token");
  
  if (!token) {
    return <Navigate to="/supplier-login" replace />;
  }

  return children;
};

export default PrivateRoute;
